import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// eslint-disable-next-line no-shadow
enum BadgeVariant {
  DARK = 'dark',
  LIGHT = 'light',
  PINK = 'pink',
  OUTLINE_LIGHT = 'outline-light',
}

/**
 * Badge
 *
 * text - The text to display inside the badge.
 * variant - The theme for the badge.
 */
@customElement('nn-badge')
export class Badge extends LitElement {
  static styles = css`
    :host body {
      border: 0;
      border-radius: 0;
      box-sizing: border-box;
      display: block;
      margin: 0;
      padding: 0;
    }
    .nn-badge {
      align-items: center;
      border: 1px solid var(--nn-badge_border-color, #000);
      border-radius: 4px;
      box-sizing: border-box;
      color: var(--nn-badge_color, #fff);
      display: inline-flex;
      font-family: 'font-medium', sans-serif;
      font-size: 12px;
      font-weight: 400;
      height: auto;
      justify-content: center;
      line-height: calc(2ex + 4px);
      min-height: 22px;
      min-width: 50px;
      padding: 0 6px;
      text-align: center;
      user-select: none;
      width: fit-content;
    }
    .nn-badge--light {
      background-color: var(--nn-badge--light_background-color, #f7f8fb);
      color: var(--nn-badge-light_color, #0e0e0e);
      min-height: 20px;
      padding: 0 8px;
    }
    .nn-badge--dark {
      background-color: var(--nn-badge--dark_background-color, #000);
    }
    .nn-badge--pink {
      background-color: var(--nn-badge--pink_background-color, #e1006c);
      border-color: var(--nn-badge--pink_border-color, #e1006c);
      margin: 0 auto;
    }
    .nn-badge--outline-light {
      background-color: transparent;
      border: 1px solid var(--nn-badge--outline-light_border-color, #fff);
    }
  `;

  @property({ type: String }) text = 'Badge';

  @property({ type: String }) variant = BadgeVariant.LIGHT;

  render() {
    return html`
      <span class="nn-badge nn-badge--${this.variant}">
        ${this.parseHtml(this.text)}
      </span>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  parseHtml(str?: any) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
}
